import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Text2Speech',
  props: {
    text: null
  },
  setup(__props: any) {

const props = __props as {
  text: string;
};



const speaking = ref(false);

const speaker = reactive(
  new (window.SpeechSynthesisUtterance ||
    window.webkitSpeechSynthesisUtterance ||
    window.mozSpeechSynthesisUtterance ||
    window.msSpeechSynthesisUtterance)(),
);

const speak = (text) => {
  speaker.lang = "en-US";
  speaker.rate = 1.5;
  speaker.voice = window.speechSynthesis.getVoices()[0];
  speaker.text = text;
  window.speechSynthesis.speak(speaker);
  speaking.value = true;

  speaker.onend = function () {
    speaking.value = false;
  };
};

const stopSpeaking = () => {
  window.speechSynthesis.cancel();
  speaker.text = "";
  speaking.value = false;
};

return { __sfc: true,props, speaking, speaker, speak, stopSpeaking }
}

})